export default __webpack_public_path__ + "static/media/Works.270121cb.svg";